document.addEventListener("DOMContentLoaded", function() {
    const popup = $(".search-popup");
    const overlay = $(".search-overlay");
    const input = $(".search-form input[type='text']");
    const clearBtn = $(".clear-btn");

    // open popup
    $(".search-toggle-btn").on("click", function () {
    popup.addClass("active");
    overlay.addClass("active");
    });

    // open popup by overlay (PC)
    overlay.on("click", function () {
    if (window.innerWidth >= 768) {
        popup.removeClass("active");
        overlay.removeClass("active");
    }
    });

    // close button (mobile)
    $(".search-close-btn").on("click", function () {
        popup.removeClass("active");
        overlay.removeClass("active");
    });

    // show clear button when input has value
    input.on("input", function () {
    if ($(this).val().trim() !== "") {
        clearBtn.show();
    } else {
        clearBtn.hide();
    }
    });

    // click clear button
    clearBtn.on("click", function () {
    input.val("").trigger("input").focus();
    });

    // Clear search button on breadcrumb
    $('.search-tag .clear-search-btn').on('click', function() {
      window.location.href = '/search?type=product&q=';
    });
});